<template>
  <div class="guides">
    <transition name="slide-fade">
      <div class="filtersBlock" v-if="filterView">
        <Filters :data="filters" />
      </div>
    </transition>
    <div class="content">
      <Cards class="itemsCard" edit remove day slider guide :removeData="remove" :items="items" @edit="setItem" @remove="setRemove" @day="setDay" @banner="setBanner" :loader="loader" />
      <Pagination :dispatchFn="'setItems'" :total="total" :page="page" @set="setPage" v-if="false" />
      <Modal :show="item" @closed="setItem(null)" :width="80" :load="loader">
        <Tabs :data="itemTabs" @set="setItemTab" />
        <div class="rows" v-if="getActiveTab === 1">
          <div class="row" v-for="(input, key) in data" :key="key">
            <Ui :data="input" :all="data" @set="setData({ key: key, value: $event })" />
          </div>
        </div>
        <div class="gallery" v-if="[2,3,4,5].indexOf(getActiveTab) > -1">
          <Cards :data="data" :removeData="removeFile" keys="gallery" v-if="getActiveTab === 2" @set="setFile" @remove="setRemoveFile" files remove button img />
          <Cards :data="data" :removeData="removeFile" keys="reviews" v-if="getActiveTab === 3" @set="setFile" @remove="setRemoveFile" files remove img />
          <Cards :data="data" :removeData="removeFile" keys="flipchart" v-if="getActiveTab === 4" @set="setFile" @remove="setRemoveFile" files remove img />
          <Cards :data="data" :removeData="removeFile" keys="flipchart2" v-if="getActiveTab === 5" @set="setFile" @remove="setRemoveFile" files remove img />
        </div>
        <div class="buttons">
          <Button label="Сохранить" @click="saveFunction" />
        </div>
        <Loader v-if="loader" />
      </Modal>
      <Modal :show="remove" @closed="setRemove(null)" :width="30" :load="loader">
        <div class="rows">
          <div class="remove" v-if="remove">
            Вы действительно хотите удалить <span v-if="remove">{{remove.title}}</span>?
          </div>
          <div class="buttons">
            <Button label="Удалить" @click="removeFunction" />
          </div>
        </div>
        <Loader v-if="loader" />
      </Modal>
      <Modal :show="removeFile" @closed="setRemoveFile(null)" :width="30" :load="loader">
        <div class="rows">
          <div class="remove" v-if="removeFile">
            Вы действительно хотите удалить изображение?
          </div>
          <div class="buttons">
            <Button label="Удалить" @click="removeFileFunction" />
          </div>
        </div>
        <Loader v-if="loader" />
      </Modal>
    </div>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import Cards from '@/components/Cards'
import Ui from '@/components/Ui'
import Filters from '@/components/views/guides/Filters'
import Tabs from '@/components/views/guides/Tabs'
import Button from '@/components/ui/Button'
import Loader from '@/components/Loader'
import Pagination from '@/components/Pagination'

import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  components: {
    Modal,
    Filters,
    Ui,
    Cards,
    Button,
    Tabs,
    Loader,
    Pagination
  },
  computed: {
    ...mapState('guides', [
      'items',
      'item',
      'data',
      'itemTabs',
      'filters',
      'remove',
      'loader',
      'filterView',
      'removeFile',
      'total',
      'page'
    ]),
    ...mapGetters('guides', [
      'getActiveTab'
    ])
  },
  methods: {
    ...mapActions('guides', [
      'setItems',
      'setItem',
      'setItemTab',
      'setData',
      'setFile',
      'saveFunction',
      'setRemove',
      'removeFunction',
      'setDay',
      'setBanner',
      'setRemoveFile',
      'removeFileFunction',
      'setPage'
    ])
  },
  mounted () {
    this.setItems()
  }
}
</script>

<style lang="scss" scoped>
.guides{
  @include box(100%, 100%, relative, null, null, null, null, null, null);
  @include flex(left, top, column);
  overflow: hidden;
  .itemsCard{
    @include size(100%, calc(100% - 0vw));
  }
  .filtersBlock{
    @include box(100%, 5vw, absolute, 0, 0, null, null, null, $header);
    @include padding(2vw, 0, 2vw, 0);
    @include flex(left, center, row);
    z-index: 5;
    box-shadow: $headerShadow;
  }
  .content{
    @include box(100%, 100%, relative, 0, 0, null, null, null, $card);
    .rows{
      @include box(100%, auto, relative, null, null, null, null, null, null);
      @include flex(left, top, row);
      flex-wrap: wrap;
      @include padding(0, 2vw, 0, 0);
      .row{
        @include box(50%, auto, relative, null, null, null, null, null, null);
        &:nth-child(1){
          @include size(20%, auto);
          @include padding(0, 0, 1vw, 0);
        }
        &:nth-child(2){
          @include size(20%, auto);
          @include padding(1vw, 0, 1vw, 0);
        }
        &:nth-child(3){
          @include size(20%, auto);
          @include padding(1vw, 0, 0, 0);
        }
        &:nth-child(4){
          @include size(20%, auto);
          @include padding(1vw, 0, 0, 0);
        }
        &:nth-child(5){
          @include size(20%, auto);
          @include padding(1vw, 0, 0, 0);
        }
        &:nth-child(6){
          @include size(20%, auto);
          @include padding(0, 1vw, 1vw, 0);
        }
        &:nth-child(7){
          @include size(20%, auto);
          @include padding(1vw, 1vw, 1vw, 0);
        }
        &:nth-child(8){
          @include size(20%, auto);
          @include padding(1vw, 1vw, 1vw, 0);
        }
        &:nth-child(9){
          @include size(20%, auto);
          @include padding(1vw, 1vw, 0, 0);
        }
        &:nth-child(10){
          @include size(20%, auto);
          @include padding(1vw, 1vw, 0, 0);
          .editor{
            @include size(100%, null);
          }
        }
        &:nth-child(11){
          @include size(20%, auto);
          @include padding(1vw, 1vw, 0, 0);
          .editor{
            @include size(100%, null);
          }
        }
        &:nth-child(12){
          @include size(20%, auto);
          @include padding(1vw, 1vw, 0, 0);
          .editor{
            @include size(100%, null);
          }
        }
        &:nth-child(13){
          @include size(100%, auto);
          @include padding(0, 1vw, 0, 0);
          .editor{
            @include size(100%, null);
          }
        }
      }
      .remove{
        @include text(0.9vw, 400, 0.05vw, null, left, $modalText);
        span{
          @include text(null, 500, null, null, null, null);
        }
      }
    }
    .gallery{
      @include box(100%, 28.3vw, relative, null, null, null, null, null, null);
      @include margin(0, 1vw, 0, 0);
      @include border(0.04vw, solid, $cardBorder, null, null, null, null);
    }
    .buttons{
      @include box(100%, auto, relative, null, null, null, null, null, null);
      @include flex(right, top, row);
      @include padding(0, 2vw, 0, 0);
      .button{
        @include size(10vw, null)
      }
    }
  }
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateY(1vw);
    opacity: 0;
  }
}
</style>
